<template>
  <div class="pb-48">
    <mia-car-edit-shared-page-header />

    <mia-car-edit-recommended-retail-price-form
      class="mt-8"
      data-highlight="unverbindliche-preisempfehlung"
    />
    <mia-car-edit-purchasing-price-form
      v-if="car.own_car"
      class="mt-16"
      data-highlight="einkauf"
    />
  </div>
</template>

<script>
import RecommendedRetailPriceForm from '@/components/cars/edit/forms/prices/RecommendedRetailPriceForm.vue'
import PurchasingPriceForm from '@/components/cars/edit/forms/prices/PurchasingPriceForm.vue'
import HighlightsElements from '@/mixins/HighlightsElements'
import SharedPageHeader from '@/components/cars/edit/SharedPageHeader.vue'

export default {
  name: 'MiaCarEditPrices',

  components: {
    'mia-car-edit-purchasing-price-form': PurchasingPriceForm,
    'mia-car-edit-recommended-retail-price-form': RecommendedRetailPriceForm,
    'mia-car-edit-shared-page-header': SharedPageHeader
  },

  mixins: [HighlightsElements],

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    }
  }
}
</script>
